type PolygonProps = {
  color?: string;
  flipped?: boolean;
};

const Polygon: React.FC<PolygonProps> = ({ color = "#2A2D31", flipped = false }) => (
  <svg
    width="8"
    height="6"
    viewBox="0 0 8 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      transform: flipped ? "rotate(180deg) scaleX(-1)" : undefined,
    }}
  >
    <path
      d="M3.44807 0.208282C3.64764 -0.0682479 4.05939 -0.0682477 4.25896 0.208282L7.61163 4.85388C7.85028 5.18456 7.61399 5.64648 7.20619 5.64648H0.500843C0.0930387 5.64648 -0.143249 5.18456 0.0954002 4.85388L3.44807 0.208282Z"
      fill={color}
    />
  </svg>
);

export default Polygon;
